// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import {
	getArrayDiff,
	getObjectKeys,
	NullPartial,
	omitKeys,
	pickKeys,
	subsetTypeHasKey,
	ValueOf,
} from "@hex-insights/core";
import { LanguageCreateInput, LanguageDetailQuery, LanguageUpdateInput } from "../../../Utilities";
import * as LanguageFormValues from "./form-values";

/**
 * Converts the given `formValues` for the create form to a GraphQL create input for the Language model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInput<K extends keyof LanguageFormValues.Create = keyof LanguageFormValues.Create>(
	formValues: LanguageFormValues.CreateSubset<K>,
): LanguageCreateInput {
	const input: NullPartial<LanguageCreateInput> = { ...formValues };
	return input as LanguageCreateInput;
}

/**
 * Converts the given `formValues` for the detail form to a GraphQL update input for the Language model.
 *
 * @param formValues The form values to convert. Generally only the changed form values.
 * @param initialFormValues The initial values of the form.
 */
export function toGQLUpdateInput<K extends keyof LanguageFormValues.Detail = keyof LanguageFormValues.Detail>(
	formValues: Partial<LanguageFormValues.DetailSubset<K>>,
	initialFormValues: LanguageFormValues.DetailSubset<K>,
): LanguageUpdateInput {
	const inputFormValues = omitKeys(formValues, ["enrollmentApplicationStudentIDs", "personIDs"]);
	const input: LanguageUpdateInput = { ...inputFormValues };

	if (
		subsetTypeHasKey(formValues, "enrollmentApplicationStudentIDs") &&
		subsetTypeHasKey(initialFormValues, "enrollmentApplicationStudentIDs") &&
		formValues.enrollmentApplicationStudentIDs !== undefined
	) {
		const { added, removed } = getArrayDiff(
			initialFormValues.enrollmentApplicationStudentIDs,
			formValues.enrollmentApplicationStudentIDs,
		);
		input.addEnrollmentApplicationStudentIDs = added;
		input.removeEnrollmentApplicationStudentIDs = removed;
	}

	if (
		subsetTypeHasKey(formValues, "personIDs") &&
		subsetTypeHasKey(initialFormValues, "personIDs") &&
		formValues.personIDs !== undefined
	) {
		const { added, removed } = getArrayDiff(initialFormValues.personIDs, formValues.personIDs);
		input.addPersonIDs = added;
		input.removePersonIDs = removed;
	}

	return input;
}

export type LanguageFormKeyMap = {
	name: "name";
	enrollmentApplicationStudentIDs: "enrollmentApplicationStudents";
	personIDs: "people";
};

export type ToFormValuesArgs<K extends keyof LanguageFormValues.Detail = keyof LanguageFormValues.Detail> = {
	language: Pick<LanguageDetailQuery["language"], ValueOf<Pick<LanguageFormKeyMap, K>>>;
	fields?: { [Key in K]: true };
};

/**
 * Converts a Language instance to its corresponding detail form values.
 *
 * @param language The instance to convert.
 * @param fields The subset of fields to include.
 */
export function toFormValues<K extends keyof LanguageFormValues.Detail = keyof LanguageFormValues.Detail>({
	language,
	fields,
}: ToFormValuesArgs<K>): LanguageFormValues.DetailSubset<K> {
	const formValues = {
		name: subsetTypeHasKey(language, "name") ? language.name : "",
		enrollmentApplicationStudentIDs: subsetTypeHasKey(language, "enrollmentApplicationStudents")
			? language.enrollmentApplicationStudents.map((e) => e.id)
			: [],
		personIDs: subsetTypeHasKey(language, "people") ? language.people.map((e) => e.id) : [],
	};
	return fields ? pickKeys(formValues, getObjectKeys(fields)) : formValues;
}
